<div class="sq-page">
	<div class="sq-card">
		<!-- Header -->
		<div class="sq-header">
			<img class="sq-logo" src="/assets/Logo.png" onerror="this.style.display='none'" alt="BPL Engineering Group" />
			<div class="sq-title">
				<h1>Approved Supplier Questionnaire</h1>
				<div class="sq-sub">BPL Engineering Group Ltd &bull; Doc 31, rev 5</div>
			</div>
		</div>

		<!-- Loading -->
		<div *ngIf="loading" class="sq-message">Loading your questionnaire&hellip;</div>

		<!-- Invalid / expired link -->
		<div *ngIf="!loading && errorMessage" class="sq-message sq-error">
			<h2>We couldn't open this questionnaire</h2>
			<p>{{ errorMessage }}</p>
		</div>

		<!-- Submitted confirmation. Shows what the server recorded, so the supplier has a receipt of what
		     they agreed to and when. -->
		<div *ngIf="submitted" class="sq-thanks">
			<div class="sq-thanks-tick">&#10003;</div>
			<h2>Questionnaire submitted</h2>
			<p class="sq-thanks-lead">
				Thank you<span *ngIf="item.companyName">, {{ item.companyName }}</span>. Your Approved Supplier
				Questionnaire has been sent to BPL Engineering Group.
			</p>

			<div class="sq-receipt">
				<div class="sq-receipt-row" *ngIf="item.submittedOn">
					<span>Submitted</span><b>{{ item.submittedOn | date:'dd MMMM yyyy, HH:mm' }}</b>
				</div>
				<div class="sq-receipt-row" *ngIf="item.completedByName">
					<span>Completed by</span><b>{{ item.completedByName }}<span *ngIf="item.completedByPosition"> ({{ item.completedByPosition }})</span></b>
				</div>
				<div class="sq-receipt-row" *ngIf="item.termsVersion">
					<span>Terms accepted</span><b>{{ item.termsVersion }}</b>
				</div>
				<div class="sq-receipt-row" *ngIf="item.signatureFingerprint">
					<span>Reference</span><b class="sq-receipt-ref">{{ item.signatureFingerprint | slice:0:16 }}</b>
				</div>
			</div>

			<p class="sq-thanks-next">
				Our purchasing team will review your responses. If we need anything further we will contact you
				using the details you provided &mdash; there is nothing more for you to do. This link is now
				closed, so please keep a copy of this page for your records.
			</p>
			<p class="sq-thanks-foot">
				BPL Engineering Group Ltd &bull; 5 Catesby Park, Kings Norton, Birmingham, B38 8SE &bull; 0121 735 2224
			</p>
		</div>

		<!-- Form -->
		<div *ngIf="!loading && !errorMessage && !submitted">
			<p class="sq-intro">Please complete all relevant questions below and sign. Where you hold certification, please attach a copy.</p>

			<dx-form [formData]="item" [showColonAfterLabel]="true" labelLocation="top" [colCount]="2">
				<!-- Company details -->
				<dxi-item itemType="group" caption="Company Details" [colSpan]="2" [colCount]="2">
					<dxi-item dataField="companyName" [label]="{ text: 'Supplier Name' }"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>
					<dxi-item dataField="telephoneFax" [label]="{ text: 'Telephone / Fax' }"></dxi-item>
					<dxi-item dataField="address" editorType="dxTextArea" [colSpan]="2" [editorOptions]="{ height: 70 }" [label]="{ text: 'Address' }"></dxi-item>
					<dxi-item dataField="website" [label]="{ text: 'Website' }"></dxi-item>
					<dxi-item dataField="outOfHoursContact" [label]="{ text: 'Out of Hours contact name(s) for supply emergencies' }"></dxi-item>
					<dxi-item dataField="productsServices" editorType="dxTextArea" [colSpan]="2" [editorOptions]="{ height: 70 }" [label]="{ text: 'Description of Products / Services' }"></dxi-item>
				</dxi-item>

				<!-- Contacts -->
				<dxi-item itemType="group" caption="Contacts" [colSpan]="2">
					<dxi-item>
						<div *dxTemplate>
							<div class="sq-contacts">
								<div class="sq-contact" *ngFor="let contact of contacts">
									<h4>{{ contact.role }}</h4>
									<dx-form [formData]="contact" [showColonAfterLabel]="true" labelLocation="top" [colCount]="1">
										<dxi-item dataField="name" [label]="{ text: 'Name' }"></dxi-item>
										<dxi-item dataField="email" [label]="{ text: 'Email' }"></dxi-item>
										<dxi-item dataField="telephone" [label]="{ text: 'Telephone' }"></dxi-item>
										<dxi-item dataField="position" [label]="{ text: 'Position' }"></dxi-item>
									</dx-form>
								</div>
							</div>
						</div>
					</dxi-item>
				</dxi-item>

				<!-- Capability -->
				<dxi-item itemType="group" caption="Capability" [colSpan]="2" [colCount]="2">
					<dxi-item dataField="ediCapability" editorType="dxSelectBox" [editorOptions]="{ items: yesNoConsidering, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Do you have EDI capability, or considering EDI?' }"></dxi-item>
					<dxi-item dataField="qmsInPlace" editorType="dxSelectBox" [editorOptions]="{ items: yesNoConsidering, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Do you have a Quality Management System (QMS) in place?' }"></dxi-item>
					<dxi-item dataField="deviationProcess" editorType="dxSelectBox" [colSpan]="2" [editorOptions]="{ items: yesNo, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Do you have a formal process / procedure / work instruction to notify BPL Engineering Group Ltd if there is a deviation from the requirements of the Order placed?' }"></dxi-item>
					<dxi-item dataField="contingencyPlan" editorType="dxSelectBox" [editorOptions]="{ items: yesNo, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Do you have a Contingency and recovery plan in case of risk to supply?' }"></dxi-item>
					<dxi-item [visible]="item.contingencyPlan === true">
						<div *dxTemplate>
							<div class="sq-upload">
								<label>If yes, please attach a copy</label>
								<dx-file-uploader [multiple]="false" uploadMode="instantly" [maxFileSize]="10485760" accept=".pdf,image/*"
									[uploadFile]="uploadCertificate.bind(this, 'contingencyPlanFileId')"></dx-file-uploader>
								<span class="sq-uploaded" *ngIf="item.contingencyPlanFileId">Attached &#10003;</span>
							</div>
						</div>
					</dxi-item>
				</dxi-item>

				<!-- Certification -->
				<dxi-item itemType="group" caption="Certification" [colSpan]="2" [colCount]="2">
					<dxi-item [colSpan]="2"><div class="sq-note">Please provide a copy of valid certification for each standard you hold.</div></dxi-item>

					<dxi-item dataField="iso9001" editorType="dxSelectBox" [editorOptions]="{ items: yesNoConsidering, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Are you ISO 9001 Certified?' }"></dxi-item>
					<dxi-item>
						<div *dxTemplate>
							<div class="sq-upload">
								<label>ISO 9001 certificate</label>
								<dx-file-uploader [multiple]="false" uploadMode="instantly" [maxFileSize]="10485760" accept=".pdf,image/*"
									[uploadFile]="uploadCertificate.bind(this, 'iso9001FileId')"></dx-file-uploader>
								<span class="sq-uploaded" *ngIf="item.iso9001FileId">Attached &#10003;</span>
							</div>
						</div>
					</dxi-item>

					<dxi-item dataField="as9100d" editorType="dxSelectBox" [editorOptions]="{ items: yesNoConsidering, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Are you AS9100D Certified?' }"></dxi-item>
					<dxi-item>
						<div *dxTemplate>
							<div class="sq-upload">
								<label>AS9100D certificate</label>
								<dx-file-uploader [multiple]="false" uploadMode="instantly" [maxFileSize]="10485760" accept=".pdf,image/*"
									[uploadFile]="uploadCertificate.bind(this, 'as9100dFileId')"></dx-file-uploader>
								<span class="sq-uploaded" *ngIf="item.as9100dFileId">Attached &#10003;</span>
							</div>
						</div>
					</dxi-item>

					<dxi-item dataField="iso14001" editorType="dxSelectBox" [editorOptions]="{ items: yesNoConsidering, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Are you ISO 14001 Certified?' }"></dxi-item>
					<dxi-item>
						<div *dxTemplate>
							<div class="sq-upload">
								<label>ISO 14001 certificate</label>
								<dx-file-uploader [multiple]="false" uploadMode="instantly" [maxFileSize]="10485760" accept=".pdf,image/*"
									[uploadFile]="uploadCertificate.bind(this, 'iso14001FileId')"></dx-file-uploader>
								<span class="sq-uploaded" *ngIf="item.iso14001FileId">Attached &#10003;</span>
							</div>
						</div>
					</dxi-item>

					<dxi-item dataField="iso45001" editorType="dxSelectBox" [editorOptions]="{ items: yesNoConsidering, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Are you ISO 45001 Certified?' }"></dxi-item>
					<dxi-item>
						<div *dxTemplate>
							<div class="sq-upload">
								<label>ISO 45001 certificate</label>
								<dx-file-uploader [multiple]="false" uploadMode="instantly" [maxFileSize]="10485760" accept=".pdf,image/*"
									[uploadFile]="uploadCertificate.bind(this, 'iso45001FileId')"></dx-file-uploader>
								<span class="sq-uploaded" *ngIf="item.iso45001FileId">Attached &#10003;</span>
							</div>
						</div>
					</dxi-item>

					<dxi-item dataField="iatf16949" editorType="dxSelectBox" [editorOptions]="{ items: yesNoConsidering, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Are you IATF 16949 Certified?' }"></dxi-item>
					<dxi-item>
						<div *dxTemplate>
							<div class="sq-upload">
								<label>IATF 16949 certificate</label>
								<dx-file-uploader [multiple]="false" uploadMode="instantly" [maxFileSize]="10485760" accept=".pdf,image/*"
									[uploadFile]="uploadCertificate.bind(this, 'iatf16949FileId')"></dx-file-uploader>
								<span class="sq-uploaded" *ngIf="item.iatf16949FileId">Attached &#10003;</span>
							</div>
						</div>
					</dxi-item>

					<dxi-item dataField="certificationConsideringNotes" editorType="dxTextArea" [colSpan]="2" [editorOptions]="{ height: 60 }" [label]="{ text: 'If &quot;No&quot;, are you considering going for it?' }"></dxi-item>
					<dxi-item dataField="canWeSupportNotes" editorType="dxTextArea" [colSpan]="2" [editorOptions]="{ height: 60 }" [label]="{ text: 'Can we support?' }"></dxi-item>
				</dxi-item>

				<!-- Assessments -->
				<dxi-item itemType="group" caption="Assessments" [colSpan]="2" [colCount]="2">
					<dxi-item dataField="ppapLevel3" editorType="dxSelectBox" [editorOptions]="{ items: ppapOptions, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Can you provide PPAP level 3?' }"></dxi-item>
					<dxi-item dataField="ppapSupportNotes" [label]="{ text: 'Can we support you doing PPAP level 3?' }"></dxi-item>
					<dxi-item dataField="mmogLeCompleted" editorType="dxSelectBox" [editorOptions]="{ items: yesNo, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Have you completed an MMOG/LE assessment?' }"></dxi-item>
					<dxi-item dataField="automotiveBusinessLevel" editorType="dxSelectBox" [editorOptions]="{ items: automotiveBusinessLevels, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Level of Automotive business' }"></dxi-item>
					<dxi-item dataField="sanctionsOrigin" editorType="dxSelectBox" [colSpan]="2" [editorOptions]="{ items: yesNoNa, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Do any elements within your material supplied to BPL originate from any country where Economic sanctions exist?' }"></dxi-item>
				</dxi-item>

				<!-- Compliance -->
				<dxi-item itemType="group" caption="Compliance" [colSpan]="2" [colCount]="2">
					<dxi-item dataField="riddorAccidents" editorType="dxSelectBox" [editorOptions]="{ items: yesNo, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Any Reportable Accidents over the last 3 years (RIDDOR)?' }"></dxi-item>
					<dxi-item dataField="riddorDate" editorType="dxDateBox" [visible]="item.riddorAccidents === true" [editorOptions]="{ displayFormat: 'dd/MM/yyyy', type: 'date' }" [label]="{ text: 'Date' }"></dxi-item>
					<dxi-item dataField="environmentalIssues" editorType="dxSelectBox" [editorOptions]="{ items: yesNo, displayExpr: 'name', valueExpr: 'id' }" [label]="{ text: 'Any Reportable Environmental Issues over the last 3 years?' }"></dxi-item>
					<dxi-item dataField="environmentalDate" editorType="dxDateBox" [visible]="item.environmentalIssues === true" [editorOptions]="{ displayFormat: 'dd/MM/yyyy', type: 'date' }" [label]="{ text: 'Date' }"></dxi-item>
				</dxi-item>

				<!-- Terms and Conditions. Doc 31 asks whether the terms are "signed and returned"; accepting them
				     here answers that question, so it is derived on submit rather than asked twice. -->
				<dxi-item itemType="group" caption="Terms and Conditions" [colSpan]="2" [colCount]="1">
					<dxi-item template="termsTemplate"></dxi-item>
					<dxi-item dataField="termsAccepted" editorType="dxCheckBox" [label]="{ visible: false }" [editorOptions]="{ text: 'I agree to and accept the Terms and Conditions for the Supply of product to BPL Engineering Group Limited' }">
						<dxi-validation-rule type="compare" message="You must accept the Terms and Conditions to submit this questionnaire." [comparisonTarget]="mustBeAccepted" comparisonType="=="></dxi-validation-rule>
					</dxi-item>
				</dxi-item>

				<!-- Completed by -->
				<dxi-item itemType="group" caption="Completed By" [colSpan]="2" [colCount]="2">
					<dxi-item dataField="completedByName" [label]="{ text: 'Name' }"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>
					<dxi-item dataField="completedByPosition" [label]="{ text: 'Position' }"></dxi-item>
					<dxi-item dataField="completedOn" editorType="dxDateBox" [editorOptions]="{ displayFormat: 'dd/MM/yyyy', type: 'date' }" [label]="{ text: 'Date' }"></dxi-item>
					<dxi-item dataField="signature" [label]="{ text: 'Signature (type your full name)' }">
						<dxi-validation-rule type="required"></dxi-validation-rule>
					</dxi-item>
					<dxi-item template="signatureNoteTemplate" [colSpan]="2"></dxi-item>
				</dxi-item>

				<div *dxTemplate="let data of 'termsTemplate'">
					<div class="sq-terms">
						<p class="sq-terms-intro">Please read the Terms and Conditions for the Supply of product to BPL Engineering Group Limited before accepting.</p>
						<a class="sq-terms-link" [href]="termsUrl" target="_blank" rel="noopener">Download the Terms and Conditions (PDF)</a>
						<p class="sq-terms-version">{{ termsVersion }}</p>
					</div>
				</div>

				<div *dxTemplate="let data of 'signatureNoteTemplate'">
					<p class="sq-signature-note">
						Typing your name above and submitting this form is the legal equivalent of signing it. We will
						record the date, time and a unique digital fingerprint of your signature as evidence of acceptance.
					</p>
				</div>
			</dx-form>

			<div class="sq-actions">
				<dx-button text="Submit Questionnaire" type="default" [disabled]="saving" (onClick)="submit()"></dx-button>
			</div>
		</div>
	</div>
</div>
